import type { BubbleMounter } from '../types'

import liveInputHandler from '@app/application/communication/handlers/live-input-bubble-handler'
import { App } from 'vue'

const excluded =
  ':not([type="checkbox"]):not([type="radio"]):not(.sf-hidden):not(th [data-name])'

export default (isPreviewMode: boolean): BubbleMounter => {
  let instances = [] as App<Element>[]

  const mount = ({
    container,
  }: {
    container: Document | HTMLElement
  }): void => {
    teardown()

    const handlersPerPath = getHandlersPerPath(container, (element) => {
      return liveInputHandler(element, isPreviewMode)
    })

    handlersPerPath.forEach((handler, path) => {
      const instance = handler.buildBubble({
        liquidInputFieldPath: path,
      })

      if (instance) {
        instances.push(instance)
      }
    })
  }

  const getHandlersPerPath = <T>(
    container: Document | HTMLElement,
    transformer: (element: Element) => T
  ): Map<string, T> => {
    const allInputFieldElements = Array.from(
      container.querySelectorAll(`[data-name]${excluded}`)
    )

    const inputInstances = new Map<string, T>()

    allInputFieldElements.forEach((element) => {
      const liquidInputFieldPath = element.getAttribute('data-name')

      if (liquidInputFieldPath) {
        inputInstances.set(liquidInputFieldPath, transformer(element))
      }
    })

    return inputInstances
  }

  const teardown = (): void => {
    instances.forEach((instance) => {
      instance.unmount()
    })

    instances = []
  }

  return {
    mount,
    teardown,
  }
}
